import * as api from '../api';
import { RECEIVE_BRANCHES } from '../constants/action-types';

export const getBranches = () => dispatch => {
  api.getBranches().then(branches => {
      dispatch(receiveBranches(branches));
      return branches;
  })
}

export const receiveBranches = branches => ({
  type: RECEIVE_BRANCHES,
  branches
});